<template>
  <Modal
    framed
    as-form
    :size="ModalSize.XL"
    :title="$t('social-post-files-modal.title')"
    :confirm-disabled="!hasUnsavedChanges"
    @cancel="back"
  >
    <template #activator>
      <Button
        :label="$t('common.edit')"
        :size="ButtonSize.SM"
        :variant="ButtonVariant.OUTLINED"
        :disabled="disabled"
        aria-label="Open edit files"
        class="lg:w-25"
      />
    </template>
    <template #body="{ formId, close }">
      <Form :id="formId" class="text-left" method="post" @submit="save(close)">
        <SocialFileList
          v-model="updatedFiles"
          :social-type="socialType"
          :no-caption="noCaption"
          :allow-videos="allowVideos"
          :is-file-editable="isFileEditable"
        />
      </Form>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { Form } from 'vee-validate';
import isEqual from 'lodash/isEqual';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  ModalSize,
  Modal,
} from '@exfluential/ui';
import { SocialFileList } from '~/pages/content/my-posts/_components/post-modal-content/_components/media-manager/_components/social-post-files-modal/_comonents';
import { ContentSocialFileDto } from '~/api/contents';
import { SocialPostPlatform } from '~/pages/content/my-posts/my-posts.constants';
import cloneDeep from 'lodash/cloneDeep';

type Props = {
  socialType: SocialPostPlatform;
  noCaption?: boolean;
  allowVideos?: boolean;
  disabled?: boolean;
  isFileEditable?: boolean;
};

withDefaults(defineProps<Props>(), {
  isFileEditable: true,
});
const media = defineModel<ContentSocialFileDto[]>({ required: true });
const updatedFiles = ref<ContentSocialFileDto[]>([]);

watch(
  () => media.value,
  (value) => {
    updatedFiles.value = cloneDeep(value);
  },
  { immediate: true, deep: true },
);

const hasUnsavedChanges = computed(() => {
  return !isEqual(media.value, updatedFiles.value);
});

const save = (close: () => void) => {
  media.value = updatedFiles.value.map((file) => ({
    ...file,
    caption: updatedFiles.value.length === 1 ? null : file.caption,
  }));
  close();
};

const back = () => {
  updatedFiles.value = cloneDeep(media.value);
};
</script>
